import { vworldDataApi } from '@/api';
export default {
    async getEupMyeonDongBoundary({ dongName, geomFilter }) {
        const response = await vworldDataApi.getEupMyeonDongBoundary(dongName, geomFilter);
        return response.data;
    },
};
